import { Injector } from '@angular/core';
export class InjectorHelper {
  static injector: Injector;
}
